document.addEventListener("DOMContentLoaded", function() {
  // Esconde botão de cashback (já existente)
  const hideCashbackButton = () => {
    if (window.location.pathname === "/cart" && window.innerWidth <= 768) {
      document.querySelectorAll(".wpcb_buttons_style_position.position_1").forEach(el => {
        el.style.display = "none";
      });
    }
  };

  // Esconde botão do WhatsApp
  const hideWhatsappButton = () => {
    if (window.location.pathname === "/cart" && window.innerWidth <= 768) {
      document.querySelectorAll(".whatsapp-button").forEach(el => {
        el.style.display = "none";
      });
    }
  };

  hideCashbackButton();
  hideWhatsappButton();

  const observer = new MutationObserver(() => {
    hideCashbackButton();
    hideWhatsappButton();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
